import React from "react";
import Button from "../../ui/Button";
import { IoCloseCircleOutline, IoCopyOutline } from "react-icons/io5";
import GradientText from "../../ui/GradientText";
import { LIST_OF_SOCIALS } from "../../../constants/newjob";
import agentIntroBanner from '../../../images/agentIntroBanner.png'
import siaFace from "../../../images/sia_face.png"
import { GlobalToggle } from "../../drawer/aiAgent/AiAgent";
import { getUserPrivilege } from "../../../features/userid";
import { useSelector } from "react-redux";
import { roleTypes } from "../../../constants/common";

const OpenJob = ({ navigate, jid, cid, setOpenPopup, navigateToJob = false, heading = "Job Created successfully!" }) => {
  const privilege = useSelector(getUserPrivilege);

  const isHiringManager = privilege === roleTypes.hiringManager;

  return (
    <div className="fixed bg-white border shadow-xl md:w-3/4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-y-auto max-h-[90vh]">
      <div className="flex flex-col space-y-6 p-10 py-20">
        <div className="flex justify-end absolute top-4 right-4">
          <Button
            variant="icon"
            size="icon"
            onClick={() => {
              setOpenPopup(false); !navigateToJob && navigate("/jobs")
            }}
            className="font-bold text-gray-500 hover:text-black text-2xl"
          >
            <IoCloseCircleOutline />
          </Button>
        </div>

        <div className="flex flex-col justify-between md:flex-row gap-6">
          <div className="md:w-[40%] flex flex-col gap-y-6 text-center">
            <div className="flex flex-col gap-2">
              <p className="text-black text-3xl font-bold w-fit">
                {heading}
              </p>
              <p className="text-base w-fit">
                Share this job link on social media
              </p>
            </div>
            <div className="flex items-center w-full border border-gray-50 overflow-x-auto rounded-md ">
              <a
                className="text-black px-5 py-4 max-w-full bg-gray-50 truncate"
                href={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                https://northstarz.ai/ats/#/careers/{jid}/{cid}
              </a>
              <Button
                onClick={() =>
                  navigator.clipboard.writeText(
                    `https://northstarz.ai/ats/#/careers/${jid}/${cid}`
                  )
                }
                size="icon"
                variant="icon"
              >
                <IoCopyOutline className="w-4 h-4" />
              </Button>
            </div>

            {/* Social Icons */}
            <div className="flex justify-between items-center">
              Share :
              <div className="flex flex-wrap justify-center gap-1">
                {LIST_OF_SOCIALS.map((item, index) => (
                  <item.Button
                    key={index}
                    url={`https://northstarz.ai/ats/#/careers/${jid}/${cid}`}
                    {...item.props}
                  >
                    <div className="p-4 border border-gray-200 rounded-md">
                      <item.Icon className="w-6 h-6 bg-white" />
                    </div>
                  </item.Button>
                ))}
              </div>
            </div>
          </div>

          <div className="w-full md:w-[45%] flex  gap-6">
            <div>
              <div className="relative rounded-xl overflow-hidden shadow-md">
                <div className="absolute inset-0 bg-black bg-opacity-50 pointer-events-none"></div>
                <iframe
                  className="w-full h-full rounded-lg relative z-0"
                  src="https://www.youtube.com/embed/d4OAV-Fup_A?si=e1SpZBlY8qy7H013"
                  title="Publish Job"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <p className="text-black font-bold text-base text-center mt-2">
                Publish Job on Job Boards
              </p>
            </div>

            {/* <div>
              <div className="relative rounded-xl overflow-hidden shadow-md">
                <div className="absolute inset-0 bg-black bg-opacity-50 pointer-events-none"></div>
                <iframe
                  className="w-full h-full rounded-lg relative z-0"
                  src="https://www.youtube.com/embed/_XBM_rkwfsM"
                  title="Publish Job"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <p className="text-black font-bold text-base text-center mt-2">
                Invite Candidates from Job Boards
              </p>
            </div> */}
          </div>
        </div>
      </div>

      {!isHiringManager &&
        <div className="relative">
          <img src={agentIntroBanner} className="w-full" alt="Job" />

          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[92%]">
            <div className="flex items-center justify-between">
              <div>
                <GradientText />
                <div className="font-semibold flex gap-2">
                  <img src={siaFace} className="w-14 h-14" alt="Job" />
                  <div className="flex flex-col">
                    <span className="text-2xl">
                      Want us to outreach candidates?
                    </span>
                    <span className="text-sm font-normal opacity-50 w-full">
                      Let us help you reach out to your potential candidates without automated process.
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex gap-3">
                <GlobalToggle onClick={() => { setOpenPopup(false); }} jobId={jid} companyId={cid} onFail={() => { if (!navigateToJob) { setOpenPopup(false); navigate("/jobs"); } }} >Start Now</GlobalToggle>
                <Button variant="secondary" onClick={() => { setOpenPopup(false); !navigateToJob && navigate("/jobs") }}>
                  No, Thanks
                </Button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default OpenJob;
